import * as React from 'react';
import { Body1 } from '@cian/ui-kit';
import * as style from './style.css';

import { ITransportPointExtendedCell } from '../../../../../../types/newbuildingsCompare';
import { TransportPointRow } from './parts';

export interface ITransportPointExtendedCellProps {
  cell: ITransportPointExtendedCell;
}

export const TransportPointExtendedCell = ({ cell }: ITransportPointExtendedCellProps): React.JSX.Element => {
  const transportPoints = cell.data?.transportPoints;

  if (!transportPoints?.length) {
    return (
      <div className={style['container']}>
        <Body1 color="text-primary-disabled">{cell.state.text ?? ''}</Body1>
      </div>
    );
  }

  return (
    <div className={style['container']}>
      {transportPoints.map((item, index) => (
        <TransportPointRow item={item} key={`${item.name}-${index}`} />
      ))}
    </div>
  );
};
